import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {ITippingHistoryViewModel} from '../../services/tipping-history/models/tipping-history-view-model.interface';
import {TippingHistoryBox} from './boxes/tipping-history/tipping-history.box';
import {TippingHistoryRecordComponent} from './record/tipping-record.component';
import {TippingHistoryFooterComponent} from './footer/tipping-history-footer.component';
import {TippingHistoryHeaderComponent} from './header/tipping-history-header.component';

interface ITippingHistoryComponentProps {
    viewModel: ITippingHistoryViewModel;
}

export const TippingHistoryComponent = observer(
    class TippingHistoryComponent extends OrbitComponent<ITippingHistoryComponentProps> {

        componentDidMount() {
            super.componentDidMount();
            this.props.viewModel.loadAllRecords();
        }


        render() {
            if(!this.props.viewModel) {
                return null;
            }

            return (
                <TippingHistoryBox>
                    <TippingHistoryHeaderComponent viewModel={this.props.viewModel}/>
                    {this.props.viewModel.records.map(record => 
                        <TippingHistoryRecordComponent key={record.tipId} record={record}/>)
                    }
                    <TippingHistoryFooterComponent viewModel={this.props.viewModel}/>
                </TippingHistoryBox>
            );
        }
    }
);